import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { authSelector, positionSelector, employeeSelector } from './../../../selectors'
import { positionAction, employeeAction } from './../../../actions/'
import CustomTable from '../../../components/table'

const header = ['Start Date', 'Position ID', 'Position Name', 'Modified By']

class ListPosition extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      positions: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.listPosition(access_token)
    this.props.getEmployeeList(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'listPositionData')) {
      this.setState({ positions: get(nextProps, 'listPositionData') })
    }
  }

  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.positions }
        handleClickEdit={ this.handleClickEdit }
        span={ this.props.span }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListPosition.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.array.isRequired,
  listPosition: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listPositionData: positionSelector.getListPosition,
  positionDeactivate: positionSelector.getDeactivatePositionData,
  redirectPosition: positionSelector.redirectPosition,
  authData: authSelector.getAuth,
  employeeList: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listPosition: positionAction.getPosition,
  resetListPosition: positionAction.resetListPosition,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListPosition)



// WEBPACK FOOTER //
// ./src/pages/position/list/index.js